import { render, staticRenderFns } from "./FCard.vue?vue&type=template&id=06a58887&"
import script from "./FCard.vue?vue&type=script&lang=js&"
export * from "./FCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports